module.exports = ".error-msg {\r\n  color: #a94442;\r\n}\r\n.fix-error-icon {\r\n  top: 27px !important;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/field-error-display/field-error-display.component.css
// module id = ./src/app/field-error-display/field-error-display.component.css
// module chunks = main